import { render } from "./TeamAdminDashBoard.vue?vue&type=template&id=736cafb9"
import script from "./TeamAdminDashBoard.vue?vue&type=script&lang=js"
export * from "./TeamAdminDashBoard.vue?vue&type=script&lang=js"

import "./TeamAdminDashBoard.vue?vue&type=style&index=0&id=736cafb9&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__